module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021.1d6923be.mp4";